var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wc-data-box',{attrs:{"title":"Totals","loading":_vm.loading}},[_c('wc-two-column-table',{attrs:{"items":_vm.divisionTotals}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }